import { memo } from "react";
import type { NavigationMenuLinkProps as RadixNavigationMenuLinkProps } from "@radix-ui/react-navigation-menu";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";
import { ArrowRight } from "lucide-react";
import Image from "next/image";


export type NavigationSubmenuItemNestProps = {
  icon: string | undefined;
  isActive?: boolean;
  ref?: React.Ref<HTMLAnchorElement | null>;
} & RadixNavigationMenuLinkProps &
  React.ComponentPropsWithoutRef<"a"> &
  LinkProps;

const NavigationSubmenuItemNest = ({
  className,
  href = "#",
  ref,
  isActive,
  icon,
  title,
  children,
  ...rest
}: NavigationSubmenuItemNestProps) => {
  return (
    <div>
      <NavigationMenuLink asChild>
        <Link
          href={href}
          passHref
          ref={ref}
          className={cn(
            "grid flex-row  items-center group hover:!bg-none hover:!bg-transparent select-none rounded-md p-2 leading-none no-underline outline-none grid-cols-[1fr]",
            { "grid-cols-[0.12fr_1fr]": !!icon },
            className
          )}
          {...rest}
        >
          {!!icon && (
            <span className={cn("flex justify-center items-center", icon)}>
              <Image src={icon} alt="icon" width={32} height={32} />
            </span>
          )}
          <div className={cn("flex flex-col", !icon && "pl-3")}>
            <div className="flex text-[16px] gap-2 group-hover:text-[#4381E5] font-medium leading-none">
              {title}
              <ArrowRight
                color="#4381E5"
                className="group-hover:flex hidden"
              />
            </div>
            <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
              {children}
            </p>
          </div>
        </Link>
      </NavigationMenuLink>
    </div>
  );
};

export default memo(NavigationSubmenuItemNest);
